import { defineMessages } from 'components/i18n';

export const status: {[key: string]: any} = defineMessages({
  'draft': {
    id: 'sale.sale.status.draft',
    defaultMessage: 'Draft'
  },
  'paid': {
    id: 'sale.sale.status.paid',
    defaultMessage: 'Paid'
  },
  'unpaid': {
    id: 'sale.sale.status.unpaid',
    defaultMessage: 'Open',
  },
  'partiallypaid': {
    id: 'sale.sale.status.partiallypaid',
    defaultMessage: 'Partially paid',
  }
});

export const recurringSaleStatus: {[key: string]: any} = defineMessages({
  'active': {
    id: 'sale.recurringSale.active',
    defaultMessage: 'Active',
  },
  'inactive': {
    id: 'sale.recurringSale.inactive',
    defaultMessage: 'Inactive',
  }
});

export const customerType = defineMessages({
  'business': {
    id: 'sale.customer.type.business',
    defaultMessage: 'Business',
  },
  'private': {
    id: 'sale.customer.type.private',
    defaultMessage: 'Private'
  }
});

export const saleItemType = defineMessages({
  'service': {
    id: 'sale.saleItem.type.service',
    defaultMessage: 'Service'
  },
  'product': {
    id: 'sale.saleItem.type.product',
    defaultMessage: 'Product',
  },
});

export const vatCodeName: { [key: string]: {id: string, defaultMessage: string} } = defineMessages({
  'V-NL-H': {
    id: 'sale.vatCode.V-NL-H',
    defaultMessage: 'NL 21%'
  },
  'V-NL-L': {
    id: 'sale.vatCode.V-NL-L',
    defaultMessage: 'NL 9%'
  },
  'V-NL-0%': {
    id: 'sale.vatCode.V-NL-0%',
    defaultMessage: 'NL 0%'
  },
  'V-NL-KOR': {
    id: 'sale.vatCode.V-NL-KOR',
    defaultMessage: 'NL KOR'
  },
  'V-NL-NVT': {
    id: 'sale.vatCode.V-NL-NVT',
    defaultMessage: 'NL exempted'
  },
  'V-NL-V': {
    id: 'sale.vatCode.V-NL-V',
    defaultMessage: 'NL reverse charged'
  },
  'V-EU-L-0%': {
    id: 'sale.vatCode.V-EU-L-0%',
    defaultMessage: 'EU products 0%'
  },
  'V-EU-D-0%': {
    id: 'sale.vatCode.V-EU-D-0%',
    defaultMessage: 'EU services 0%'
  },
  'V-EX-L-0%': {
    id: 'sale.vatCode.V-EX-L-0%',
    defaultMessage: 'Export products 0%'
  },
  'V-EX-D-0%': {
    id: 'sale.vatCode.V-EX-D-0%',
    defaultMessage: 'Export services 0%'
  },
  // 'V-BE-H': {
  //   id: 'sale.vatCode.V-BE-H',
  //   defaultMessage: 'BE 0%'
  // },
  // 'V-DE-H': {
  //   id: 'sale.vatCode.V-DE-H',
  //   defaultMessage: 'DE 0%'
  // },
});
